export default __webpack_public_path__ + "search-on-phone-c477c4a6a7868a8ece24a61454e8bc06.digested.webp";